<template lang="">
  <v-card width="100vw" height="90vh" elevation="0">
    <v-container>
      <v-img
        contain
        max-height="425"
        src="../../../public/img/undraw_No_data_re_kwbl.png"
      >
      </v-img>
      <v-row justify="center" align="center">
        <v-col cols="12" justify="center" align="center">
          <div class="title">
            Vaya, parece que no hay propiedades por mostrar.
          </div>
        </v-col>
        <v-col cols="12" justify="center" align="center">
          <div class="subtitle-2 grey--text">
            No se encontraron propiedades, intenta recargando.
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
export default {
  name: "NotFoundPropertys"
};
</script>
